var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneMainMsg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 12.1667H2.75V13.4167H1.5V12.1667Z",
    fill: "#474350"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 12.1667H16.5V13.4167H15.25V12.1667Z",
    fill: "#474350"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 5.91675H14V7.16675H12.75V5.91675Z",
    fill: "#474350"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 7.16675H12.75V8.41675H11.5V7.16675Z",
    fill: "#474350"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 4.66675H15.25V5.91675H14V4.66675Z",
    fill: "#474350"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 4.66675H4V5.91675H2.75V4.66675Z",
    fill: "#474350"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4 5.91675H5.25V7.16675H4V5.91675Z",
    fill: "#474350"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 7.16675H6.5V8.41675H5.25V7.16675Z",
    fill: "#474350"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 12.1667H17.75V3.41675H16.5V2.16675H15.25V4.66675H16.5V12.1667Z",
    fill: "#474350"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 9.66675V8.41675H6.5V9.66675H11.5Z",
    fill: "#474350"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3.41675H0.25V12.1667H1.5V4.66675H2.75V2.16675H1.5V3.41675Z",
    fill: "#474350"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 0.916748V2.16675H15.25V0.916748H2.75Z",
    fill: "#474350"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 13.4167V14.6667H15.25V13.4167H2.75Z",
    fill: "#474350"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneMainMsg);
export default __webpack_public_path__ + "static/media/phone_main_msg.064e1f74dc57bd777171ffa9dd5bb97a.svg";
export { ForwardRef as ReactComponent };